import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-project-bindding',
  templateUrl: './project-bindding.component.html',
  styleUrls: ['./project-bindding.component.css']
})
export class ProjectBinddingComponent {
  mode: 'add' | 'edit' | 'view' = 'view';
  biddingForm: FormGroup;
  resourceId: string | null = null;
  vendorsList = ['Vendor A', 'Vendor B', 'Vendor C'];
  searchKeyword: any;
  projectData: any;
  bidId: any;
  projectTypeOptions = [
    { value: 'CONSTRUCTION', label: 'Construction' },
    { value: 'ROAD', label: 'Road' },
    { value: 'UTILITIES', label: 'Utilities' },
    { value: 'CONSULTANCY', label: 'Consultancy' }
  ];
  constructor(private route: ActivatedRoute, private fb: FormBuilder, private apiService: ApiService,
      private toastrMsgService: ToastrMsgService,
      private router: Router) {
    this.biddingForm = this.fb.group({
      clientName: ['', Validators.required],
      address: ['', Validators.required],
      logo: ['', Validators.required],
      contactName: ['', Validators.required],
      clientCode: [''],
      email: ['', [Validators.required, Validators.email]],
      mobile: [''],
      project_id: ['', Validators.required],
      projectType: [''],
      locationAddress: [''],
      latLongStart: [''],
      latLongEnd: [''],
      totalScope: [''],
      segmentsLatLongs: [''],
      segmentDescription: [''],
      workDescription: [''],
      bidStartDate: [''],
      bidEndDate: [''],
      vendors: [[]],
      supplierContacts: [''],
      bidPackageSentDate: [''],
      bidFees: ['']
    });
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.bidId = params['id'];
    });
    this.mode = this.route.snapshot.data['mode'] || 'add';
    this.resourceId = this.route.snapshot.paramMap.get('id');

    this.buildForm();

    if (this.bidId) {
      this.fetchData(this.bidId);
    }

    if (this.mode === 'view') {
      this.biddingForm.disable();
    }
  }

  buildForm() {
    this.biddingForm = this.fb.group({
      clientName: ['', Validators.required],
      address: ['', Validators.required],
      logo: ['', Validators.required],
      contactName: ['', Validators.required],
      clientCode: [''],
      email: ['', [Validators.required, Validators.email]],
      mobile: [''],
      project_id: ['', Validators.required],
      projectType: [''],
      locationAddress: [''],
      latLongStart: [''],
      latLongEnd: [''],
      totalScope: [''],
      segmentsLatLongs: [''],
      segmentDescription: [''],
      workDescription: [''],
      bidStartDate: [''],
      bidEndDate: [''],
      vendors: [[]],
      supplierContacts: [''],
      bidPackageSentDate: [''],
      bidFees: ['']
    });
    this.fetchProject();
  }

  setMode(newMode: 'add' | 'edit' | 'view') {
    this.mode = newMode;
    if (newMode === 'view') {
      this.biddingForm.disable();
    } else {
      this.biddingForm.enable();
    }
  }

  onSubmit() {
    if (this.biddingForm.valid) {
      const formValue = this.biddingForm.value;
      const payload = {
        projectId: formValue.project_id,
        clientName: formValue.clientName,
        address: formValue.address,
        logo: formValue.logo,
        contactName: formValue.contactName,
        clientCode: formValue.clientCode,
        email: formValue.email,
        mobile: formValue.mobile,
        projectType: formValue.projectType || null,
        locationAddress: formValue.locationAddress,
        latLongStart: formValue.latLongStart,
        latLongEnd: formValue.latLongEnd,
        totalScope: formValue.totalScope,
        segmentsLatLongs: formValue.segmentsLatLongs,
        segmentDescription: formValue.segmentDescription,
        workDescription: formValue.workDescription,
        bidStartDate: formValue.bidStartDate,
        bidEndDate: formValue.bidEndDate,
        vendors: formValue.vendors,
        supplierContacts: formValue.supplierContacts,
        bidPackageSentDate: formValue.bidPackageSentDate,
        bidFees: formValue.bidFees
      };

      if (this.bidId) {
        this.apiService.updateProjectBidding(this.bidId, payload).subscribe({
          next: () => {
            this.toastrMsgService.success('Bidding updated successfully');
            this.router.navigate(['/home/biding-list']);
          },
          error: (err) => {
            this.toastrMsgService.error(err?.error?.errorMessage || err?.error?.error || 'Failed to update');
          }
        });
      } else {
        this.apiService.saveProjectBidding(payload).subscribe({
          next: () => {
            this.toastrMsgService.success('Bidding created successfully');
            this.router.navigate(['/home/biding-list']);
          },
          error: (err) => {
            this.toastrMsgService.error(err?.error?.errorMessage || err?.error?.error || 'Failed to create');
          }
        });
      }
    } else {
      this.biddingForm.markAllAsTouched();
    }
  }

  fetchProject() {
    this.apiService.getProjectCommonAll({ limit: 1000 }).subscribe({
      next: (res: any) => {
        this.projectData = res?.data ?? res ?? [];
      },
      error: (err) => {
        this.toastrMsgService.error(err?.error?.errorMessage || 'Failed to load projects');
      }
    });
  }

  fetchData(id: string) {
    this.apiService.getProjectBiddingId(id).subscribe({
      next: (res: any) => {
        const data = res?.data ?? res;
        if (data) {
          this.biddingForm.patchValue({
            project_id: data.projectId,
            projectType: data.projectType || '',
            clientName: data.clientName,
            address: data.address,
            logo: data.logo,
            contactName: data.contactName,
            clientCode: data.clientCode,
            email: data.email,
            mobile: data.mobile,
            locationAddress: data.locationAddress,
            latLongStart: data.latLongStart,
            latLongEnd: data.latLongEnd,
            totalScope: data.totalScope,
            segmentsLatLongs: data.segmentsLatLongs,
            segmentDescription: data.segmentDescription,
            workDescription: data.workDescription,
            bidStartDate: data.bidStartDate,
            bidEndDate: data.bidEndDate,
            vendors: data.vendors || [],
            supplierContacts: data.supplierContacts,
            bidPackageSentDate: data.bidPackageSentDate,
            bidFees: data.bidFees
          });
        }
      },
      error: (err) => {
        this.toastrMsgService.error(err?.error?.errorMessage || 'Failed to load bidding');
      }
    });
  }

}
